import {
    Modal,
    Form,
    Container,
    Row,
    Col,
    Button
} from "react-bootstrap";
import axios from 'axios';
import React, { useState, useEffect} from "react";

import "react-modern-calendar-datepicker/lib/DatePicker.css";
import { Calendar, utils } from "react-modern-calendar-datepicker";
import { useForm } from "react-hook-form";
// import DatePicker from '../date-picker/date-picker';
import SyncLoader from "react-spinners/SyncLoader";
import {timeConverter} from './time-converter/time-converter';
import {RemoveUnavailableSlots} from './remove-unavailable-slots/remove-unavailable-slots';

export default function BookTimeModal(props) {


    const originalSlots = [8,9,10,11,12,13,14,15,16,17,18,19];

    const clinic = props.clinicData;
    const today = new Date();
    const [availableSlots, setAvailableSlots] = useState(originalSlots)
    const [dentist, setDentist] = useState(clinic.dentists[0]._id || false)
    const [date, setDate] = useState(timeConverter(today.getFullYear(), today.getMonth(), today.getUTCDate()))
    const [loading, setLoading] = useState(false);
    const [selectedDay, setSelectedDay] = useState(utils().getToday());

    const handleClose = () => props.setShow(false);

    const {register} = useForm();



    useEffect(() => {
        setLoading(true)
        axios.post("https://uae-dentist-backend.herokuapp.com/schedule/one-dentist-day", {dentist, date})
        .then((result) => {
            console.log(result.data.schedule)
            const times = result.data.schedule;
            const availSlots = RemoveUnavailableSlots(times, originalSlots)
            console.log(availSlots);
            setAvailableSlots(availSlots)

            setLoading(false);
            // parse_Schedule(0, dentistsWithBookings.data.dentists)
        })
        .catch(function (error) {
            console.log(error);
        });
            // eslint-disable-next-line
    }, []);
    
    // const onSubmit = async (data) => {
    //     console.log('Hello: ' + data);
    // }

    const handleClick = async (data) => {
        let newDate = timeConverter(selectedDay.year, selectedDay.month, selectedDay.day)
        newDate.setHours(data);
        console.log('Hello: ' + newDate);
        props.setDentist(dentist);
        props.setShowNextModal(true);
        props.setBookingTime(newDate)
        handleClose();
    }

    const pickDentist = (dentist) => {
        setLoading(true)
        setDentist(dentist)
        axios.post("https://uae-dentist-backend.herokuapp.com/schedule/one-dentist-day", {dentist, date})
        .then((result) => {
            console.log(result.data.schedule)
            const times = result.data.schedule;
            const availSlots = RemoveUnavailableSlots(times, originalSlots)
            console.log(availSlots);
            setAvailableSlots(availSlots)
            setLoading(false);
            // parse_Schedule(0, dentistsWithBookings.data.dentists)
        })
        .catch(function (error) {
            console.log(error);
        });
    };

    
    const handleDateChange = (event) => {
        setSelectedDay(event);
        const newDate = timeConverter(event.year, event.month, event.day)
        setDate(newDate);
        axios.post("https://uae-dentist-backend.herokuapp.com/schedule/one-dentist-day", {dentist, date: newDate})
        .then((result) => {
            console.log(result.data.schedule)
            const times = result.data.schedule;
            const availSlots = RemoveUnavailableSlots(times, originalSlots)
            console.log(availSlots);
            setAvailableSlots(availSlots)
            setLoading(false);
            // parse_Schedule(0, dentistsWithBookings.data.dentists)
        })
        .catch(function (error) {
            console.log(error);
        });
    };



        return (
          <Modal show={true} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title >Book time</Modal.Title>
            </Modal.Header>
             <Modal.Body className='mx-auto'>
                <Form.Group controlId="dentist">
                <Form.Label>Provider</Form.Label>
                    <Form.Control onChange={(event)=>pickDentist(event.target.value)} as="select" name="dentist" ref={register} custom>
                    <option disabled>- All -</option>
                    {clinic.dentists.map((dentist, idx) => (
                    <option value={dentist._id} key={idx}>{dentist.full_name}</option>
                    ))}
                    </Form.Control>
                </Form.Group> 
                <Calendar
                className='mx-auto'
                value={selectedDay}
                onChange={handleDateChange}
                minimumDate={utils().getToday()}
                />
            </Modal.Body>
            <SyncLoader size={15} margin={2} color={"#123abc"} loading={loading}/>
            <Container  id='no-min-height' className='my-3 text-center' >
                <h4>Times for {selectedDay.day}/{selectedDay.month}/{selectedDay.year}</h4>
                <Row xs={2} md={3} lg={3} className='mx-auto'  >
                </Row>

            <Row xs={2} md={3} lg={4} className='mx-auto'>
            {!loading &&
            availableSlots.map((slot, idx) => (
                <Col xs={5} md={3} lg={3} key={idx} className='p-0' >
                    <Button className='w-75' onClick={() => handleClick(slot)}>
                        { (slot<10?'0':'') + slot + ':00' }
                    </Button>
                </Col>
            ))}
            </Row>
            </Container>
          </Modal>  
        );
      }
    